import { ILocation } from '@models/interfaces/ILocation';
import { isValidCoordinate } from '@utils/coordinates';
import { Coordinate } from 'openlayers';
import { DefaultLocationFormatter } from '../default-location-formatter';

export class DcasLocationFormatter extends DefaultLocationFormatter {
  format(location: ILocation): string[] {
    const jsonMiscData = this.parseMiscData(location.LocationMiscData);

    const miscDataFields: string[] = [
      this.getAttributeValue('REFHIGHWAYS_SNAME', jsonMiscData),
      this.getAttributeValue('REFTRACKS_SNAME', jsonMiscData),
      this.getAttributeValue('SFULLTEXT', jsonMiscData)
    ];
    const street: string = [location.PlaceName, location.StreetNumber].filter(s => s).join(' ');
    const city: string = [location.Zip, location.CityName].filter(s => s).join(' ');
    const areaName: string = location.Area1Name ? `(${location.Area1Name})` : '';
    const digiCode: string = this.getDigiCode(jsonMiscData);

    const line1: string = [...miscDataFields, location.AliasName, street, city, areaName, digiCode].filter(s => s).join(', ');

    const olCoordinate: Coordinate = [location.coordinate.x, location.coordinate.y];
    const coordinates: string = isValidCoordinate(olCoordinate) ? olCoordinate.filter(s => s).join(', ') : null;
    const line2: string = coordinates ? `${this.translate.instant('Mobile.Coordinates')}: ${coordinates}` : null;

    return [line1, line2].filter(s => s);
  }
}
